export interface ILanguage {
  id: string;
  title: string;
}

export const languagesItems: ILanguage[] = [
  {
    id: "0",
    title: "English (United States)",
  },
  {
    id: "1",
    title: "French",
  },
  {
    id: "2",
    title: "Ukrainian",
  },
];